const prefix = 'insuranceContracts';

export const CREATE = `${prefix}/CREATE`;
export const ACTIVATE = `${prefix}/ACTIVATE`;
export const FETCH_FILTERED = `${prefix}/FETCH_FILTERED`;
export const FIND = `${prefix}/FIND`;
export const CANCEL = `${prefix}/CANCEL`;
